<template>
  <div>
    <b-row align-v="center" slot="header">
      <b-col cols="8">
        <h4 class="mb-0"><i :class="icon"></i> {{ title }}</h4>
      </b-col>
      <b-col v-if="editable" cols="4" class="text-right">
        <a href="#" class="btn-inner--icon" @click.prevent="handleClick"
          ><i class="fas fa-pencil-alt" float="right"></i
        ></a>
      </b-col>
    </b-row>

    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "data-row",
  props: {
    editable: true,
    icon: "",
    title: "",
  },
  methods: {
    handleClick(evt) {
      this.$emit("click", evt);
    },
  },
};
</script>